/**
 * Payload for GES → client match kicks. The server emits this when something has invalidated the
 * player's right to remain in the match (today: their Play After GameShow window has expired).
 * The reason union grows as new kick paths are added; clients should switch on it exhaustively.
 */
export const MATCH_KICK_REASON_PAGS_EXPIRED = 'PAGS_EXPIRED' as const;

export type MatchKickReason = typeof MATCH_KICK_REASON_PAGS_EXPIRED;

export interface IMatchKickData {
  reason: MatchKickReason;
}
